import React, { useEffect, useState } from "react";
import { C } from "../constants.js";
import { apiFetch } from "../api.js";
import { Spinner } from "../components/Spinner.jsx";
import { formatAuditTime, EVENT_TYPE_CONFIG } from "../utils.js";

export function MatterActivityCard({ matterId, setPage }) {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch(`/api/matters/${matterId}/activity?limit=10`)
      .then(data => { setEntries(data.data || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [matterId]);

  const dotColor = (type) => {
    const cfg = EVENT_TYPE_CONFIG[type];
    if (!cfg) return C.textLight;
    if (cfg.variant === "gold") return C.gold;
    if (cfg.variant === "navy") return C.navy;
    if (cfg.variant === "success") return C.success;
    return C.textLight;
  };

  return React.createElement("div", {
    style: {
      background:"#fff", borderRadius:"12px", padding:"24px 28px", marginTop:"20px",
      border:`1px solid ${C.warmGray}`,
    }
  },
    React.createElement("div", { style: { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"16px" } },
      React.createElement("h3", {
        style: { fontFamily:"'Playfair Display',serif", fontSize:"17px", fontWeight:600, color:C.navy, margin:0 }
      }, "Recent Activity"),
      React.createElement("button", {
        onClick: () => setPage("audit-log"),
        style: {
          border:"none", background:"none", color:C.gold, cursor:"pointer",
          fontSize:"13px", fontWeight:600,
        }
      }, "View All \u2192"),
    ),

    loading
      ? React.createElement("div", { style: { textAlign:"center", padding:"20px" } }, React.createElement(Spinner, { size: 20 }))
      : entries.length === 0
        ? React.createElement("p", { style: { fontSize:"13px", color:C.textMuted, textAlign:"center", padding:"16px 0" } }, "No activity recorded yet")
        : React.createElement("div", { style: { display:"flex", flexDirection:"column", gap:"0" } },
            entries.map((e, i) =>
              React.createElement("div", {
                key: e.id,
                style: {
                  display:"flex", gap:"12px", paddingBottom: i < entries.length - 1 ? "12px" : "0",
                  position:"relative",
                }
              },
                // Timeline line + dot
                React.createElement("div", { style: { display:"flex", flexDirection:"column", alignItems:"center", width:"20px", flexShrink:0 } },
                  React.createElement("div", {
                    style: {
                      width:10, height:10, borderRadius:"50%", background:dotColor(e.event_type),
                      border:"2px solid #fff", boxShadow:`0 0 0 2px ${dotColor(e.event_type)}30`,
                      flexShrink:0, marginTop:"3px",
                    }
                  }),
                  i < entries.length - 1 && React.createElement("div", {
                    style: { width:2, flex:1, background:C.warmGray, marginTop:"4px" }
                  }),
                ),
                // Content
                React.createElement("div", { style: { flex:1, minWidth:0 } },
                  React.createElement("div", { style: { fontSize:"13px", color:C.textDark, lineHeight:1.4 } }, e.description),
                  React.createElement("div", { style: { fontSize:"11px", color:C.textLight, marginTop:"2px" } }, formatAuditTime(e.created_at, true)),
                ),
              )
            ),
          ),
  );
}

